var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Learning Type / TE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6 9.13787C17.0734 9.06536 17.5 9.43164 17.5 9.9105V18H16.6V9.13787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18C11.5 16.3431 12.8431 15 14.5 15C16.1569 15 17.5 16.3431 17.5 18C17.5 19.6569 16.1569 21 14.5 21C12.8431 21 11.5 19.6569 11.5 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1294 10.3992L16.6 11.1971V8.87858C16.6 8.14882 17.1404 7.52495 17.8803 7.40054L21.7289 6.75339C21.8898 6.72635 22.0281 6.86522 21.9951 7.02058L21.3149 10.2233C21.2958 10.3132 21.2224 10.3828 21.1294 10.3992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.1C2 4.49249 2.49249 4 3.1 4H13.9C14.5075 4 15 4.49249 15 5.1C15 5.70751 14.5075 6.2 13.9 6.2H3.1C2.49249 6.2 2 5.70751 2 5.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10.1C2 9.49249 2.49249 9 3.1 9H10.9C11.5075 9 12 9.49249 12 10.1C12 10.7075 11.5075 11.2 10.9 11.2H3.1C2.49249 11.2 2 10.7075 2 10.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 15.1C2 14.4925 2.49249 14 3.1 14H7.9C8.50751 14 9 14.4925 9 15.1C9 15.7075 8.50751 16.2 7.9 16.2H3.1C2.49249 16.2 2 15.7075 2 15.1Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.7047d260725192a38d2134836733c750.svg";
export { ForwardRef as ReactComponent };